import fetch from 'isomorphic-unfetch';

// Copied this from the api.js from GDPR footer component and simplified it since we only
// have a single GET request in this api.
const request = async path => {
  const init = {
    method: 'get',
  };

  init.headers = {
    'Content-Type': 'application/json',
  };

  const response = await fetch(path, init);

  if (response.status >= 400) {
    const e = new Error('Get session time request failed.');
    e.response = await response.json();
    e.code = response.status;
    throw e;
  }

  return await response.json();
};

export async function isSessionExpired() {
  return request('/api/isSessionExpired/');
}
